import axios from "axios";
import { data } from "jquery";

export default {
    namespaced: true,

    state: {
        constantMapAreas: null,
        dialectSheetConstantGroups: {},
        dialectSheetsConstants: [],

        maps: [],
        allMapsFilters: {
            sort: "id",
            search: null,
            sortOrder: "desc",
            offset: 0,
            limit: 50,
        },
        totalCount: 0,
        filteredResultsCount: 0,

        //public data
        publishedMaps: [],
        groupLabelMap: {
            0: "Pilsētas",
            1: "Lībiskais dialekts",
            2: "Vidus dialekts",
            3: "Augšzemnieku dialekts",
        },
    },

    getters: {
        constantMapAreas(state) {
            return state.constantMapAreas;
        },
        dialectSheetConstantGroups(state) {
            return state.dialectSheetConstantGroups;
        },
        dialectSheetsConstants(state) {
            return state.dialectSheetsConstants;
        },

        maps(state) {
            return state.maps;
        },
        publishedMaps(state) {
            return state.publishedMaps;
        },
        totalCount(state) {
            return state.totalCount;
        },
        filteredResultsCount(state) {
            return state.filteredResultsCount;
        },
    },

    mutations: {
        SET_CONSTANT_MAP_AREAS(state, features) {
            state.constantMapAreas = {
                type: "FeatureCollection",
                name: "LV_pagasti_WGS84",
                crs: {
                    type: "name",
                    properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
                },
                features: features,
            };
        },
        SET_CONSTANT_DIALECT_GROUPS(state, groups) {
            state.dialectSheetConstantGroups = groups;
        },
        SET_DIALECT_SHEET_CONSTANTS(state, data) {
            state.dialectSheetsConstants = data;
        },

        SET_ALL_MAPS(state, maps) {
            state.maps = maps;
        },
        SET_ALL_PUBLISHED_MAPS(state, maps) {
            state.publishedMaps = maps;
        },
        SET_FILTERS(state, value) {
            state.allMapsFilters = value;
        },
        SET_FILTERED_RESULTS_TOTAL_COUNT(state, count) {
            state.filteredResultsCount = count;
        },
    },

    actions: {
        async getAllMaps({ commit, state }) {
            return await axios
                .get("/api/get-all-maps", {
                    params: state.allMapsFilters,
                })
                .then((response) => {
                    // console.log("response.data", response.data);
                    commit("SET_ALL_MAPS", response.data.maps);
                    commit(
                        "SET_FILTERED_RESULTS_TOTAL_COUNT",
                        response.data.filterd_results_count
                    );
                    return response;
                });
        },
        async getPublishedMaps({ commit, state }) {
            return await axios
                .get("/api/get-published-maps")
                .then((response) => {
                    // console.log("response.data", response.data);
                    commit("SET_ALL_PUBLISHED_MAPS", response.data);
                    return response;
                });
        },
        async getMapData({ commit, state }) {
            return await axios.get("/api/get-map-data").then((response) => {
                // console.log("response", response);
                commit("SET_DIALECT_SHEET_CONSTANTS", response.data);

                const features = prepareMapData(response.data);
                const dialectSheetConstantGroups =
                    prepareDialectSheetConstantGroups(response.data, state);
                commit("SET_CONSTANT_MAP_AREAS", features);
                commit(
                    "SET_CONSTANT_DIALECT_GROUPS",
                    dialectSheetConstantGroups
                );
                return response.data;
            });
        },
        async createNewMap({ commit }, payload) {
            return await axios.post("/api/create-map", payload);
        },
        async getMap({ commit }, id) {
            return await axios.get("/api/get-map", {
                params: { id },
            });
        },
        async updateMap({ commit }, payload) {
            await axios.post("/api/update-map", payload).then((response) => {});
        },
        async deleteMap({ commit }, id) {
            await axios.post("/api/delete-map", { id }).then((response) => {});
        },
        async updateData({ dispatch }) {
            await dispatch("getAllMaps");
        },
        async getHomePageMap({ commit }) {
            return await axios
                .get("/api/get-home-page-map")
                .then((response) => {
                    return response;
                });
        },
    },
};

function prepareMapData(data) {
    const features = [];
    for (let i in data) {
        const feature = {
            type: "Feature",
            properties: {
                sub_dialect: data[i].sub_dialect,
                parish: data[i].parish,
                sequence_number: data[i].sequence_number,
                id: data[i].id,
            },
            geometry: data[i].geometry,
        };
        features.push(feature);
    }
    return features;
}

function prepareDialectSheetConstantGroups(data, state) {
    const dialectSheetConstantGroups = {};
    for (let i in data) {
        data[i].checked = false;
        if (!dialectSheetConstantGroups[data[i].dialect]) {
            dialectSheetConstantGroups[data[i].dialect] = {};
            dialectSheetConstantGroups[data[i].dialect].subDialects = [];
            dialectSheetConstantGroups[data[i].dialect].allSelected = false;
            dialectSheetConstantGroups[data[i].dialect].dialectGroupName =
                state.groupLabelMap[data[i].dialect];
        }
        dialectSheetConstantGroups[data[i].dialect].subDialects.push(data[i]);
        dialectSheetConstantGroups[data[i].dialect].attributeIdAppliedToallId =
            null;
        dialectSheetConstantGroups[data[i].dialect].mapAttributes = [];
        dialectSheetConstantGroups[data[i].dialect].mapPatterns = [];
    }
    // console.log("dialectSheetConstantGroups", dialectSheetConstantGroups);
    return dialectSheetConstantGroups;
}
